import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { OrganizationService } from '../../../services/organization.service';
import { WatchOrganizationService } from '../../../services/watch-organization.service';

@Component({
  selector: 'modal-invite-team-member',
  template: require('./modal-invite-team-member.component.pug'),
  styles: [require('./modal-invite-team-member.component.css').toString()],
})
export class ModalInviteTeamMemberComponent implements OnInit {
  note: string = null;
  link: string = null;
  orgId: string = null;

  // -------------------------------------------------------------------
  constructor(
    public bsModalRef: BsModalRef,
    private orgService: OrganizationService,
  ) {}

  // -------------------------------------------------------------------
  ngOnInit() {}

  // -------------------------------------------------------------------
  onCancel() {
    this.bsModalRef.hide();
  }

  copied = false;

  // -------------------------------------------------------------------
  copyLink(val: string) {
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);

    this.copied = true;
  }

  // -------------------------------------------------------------------
  save(data: any, onsuccess: onSmartSuccess, onfailure: onSmartFailure) {
    this.orgService.generateTeamMemberInvite(
      this.orgId,
      this.note,
      result => {
        onsuccess();
        this.link = result.link;
      },
      error => {
        onfailure(error);
      },
    );
  }
}
